/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { UpdateLocationResponse, UpdateLocationVars } from '../openapi-types.gen.js';

export type { UpdateLocationResponse, UpdateLocationVars } from '../openapi-types.gen.js';

export const useUpdateLocation = createMutationHook<UpdateLocationVars, UpdateLocationResponse, unknown>({
  specName: 'useUpdateLocation',
  path: '/v1/me/location',
  method: 'PATCH',
  resolveUrl: (vars: UpdateLocationVars) => `/v1/me/location`,
  buildBody: (vars: UpdateLocationVars) => ({ country: vars.country }),
  parseResponse: (raw: unknown): UpdateLocationResponse => raw as UpdateLocationResponse,
  optimistic: [{
    queryKey: ['accounts', 'viewer'],
    entityGraph: true,
    reconcileQueryKey: ['me', 'detail'],
    reconcileSpecName: 'useGetMe',
    apply: (prev: any, vars: UpdateLocationVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPrivateAccountLocationOptimistic as unknown as (prev: any, vars: UpdateLocationVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => any)(next, vars, queryKey, queryClient, viewerScope, networkScope);
      return next;
    },
  }, {
    queryKey: ['users', 'entity'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: UpdateLocationVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPublicUserProfileOptimistic as unknown as (prev: any, vars: UpdateLocationVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
